export const HEADER_CONTENT_VARIANT = Object.freeze({
  green: 'GREEN',
  grey: 'GREY'
})
